import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'default',
  size = 'default',
  ...props
}, ref) => {
  return <button className={cn('inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', {
    'bg-primary text-primary-foreground hover:bg-primary/90': variant === 'default',
    'hover:bg-accent hover:text-accent-foreground': variant === 'ghost',
    'border border-input bg-background hover:bg-accent hover:text-accent-foreground': variant === 'outline'
  }, {
    'h-10 px-4 py-2': size === 'default',
    'h-9 rounded-md px-3': size === 'sm',
    'h-11 rounded-md px-8': size === 'lg',
    'h-10 w-10': size === 'icon'
  }, className)} ref={ref} {...props} data-id="element-646" />;
});
Button.displayName = 'Button';